export default "__VITE_ASSET__BXVKUHeX__"